import { FC, SVGAttributes } from 'react';

const Heat: FC<SVGAttributes<SVGElement>> = (props) => {
    return (
        <svg {...props} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path
                d="M12 2.28711C9.71429 4.9694 9.71429 9.31911 12 12.0014C14.2857 14.6837 14.2857 19.0334 12 21.7157M5.71429 4.57282C3.42857 6.62425 3.42857 9.94997 5.71429 12.0014C8 14.0528 8 17.3785 5.71429 19.43M18.2857 4.57282C16 6.62425 16 9.94997 18.2857 12.0014C20.5714 14.0528 20.5714 17.3785 18.2857 19.43"
                stroke="currentColor"
                strokeWidth="1.5"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
        </svg>
    );
};

export default Heat;
